// extracted by mini-css-extract-plugin
export default {"kpi-cards-container":"CostConsumedCards_kpi-cards-container__+22Nl"};